import { v4 as uuid } from 'uuid';

const CLIENT_IDENTIFIER_KEY = 'certhon_app_client_identifier';

let identifier = '';

/**
 * Get or generate a persistent client identifier (UUID) for this browser.
 * Stored in localStorage and reused across sessions.
 */
export function getClientIdentifier(): string {
  if (!identifier) {
    identifier = localStorage.getItem(CLIENT_IDENTIFIER_KEY) || '';
    if (!identifier) {
      identifier = uuid();
      localStorage.setItem(CLIENT_IDENTIFIER_KEY, identifier);
    }
  }
  return identifier;
}
